import { Send } from "lucide-react";
import { useState } from "react";

export default function LeadNoteEditor({ onAddNote, state }) {
  const [note, setNote] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    if (await onAddNote(note)) setNote("");
  };
  return <form onSubmit={submit} data-testid="lead-note-form"><label>Internal note<textarea required value={note} onChange={(event) => setNote(event.target.value)} data-testid="lead-note-input" /></label>{state === "error" && <p className="form-error" data-testid="lead-note-error">The internal note could not be saved.</p>}<button className="button button--red" disabled={state === "loading"} data-testid="lead-note-submit-button"><Send size={16} />{state === "loading" ? "Saving…" : "Add note"}</button></form>;
}